import {
  formatCurrency,
  formatMuqamiName,
  formatPercent,
} from "./analyticsUtils";

const AnalyticsMuqamiRankingTable = ({
  rows = [],
  loading,
  error,
  includeLocalFund,
  categoryLabel = "All Categories",
}) => {
  const totalAmount = rows.reduce((sum, row) => sum + Number(row.amount || 0), 0);

  return (
    <div className="rounded-3xl bg-white p-5 shadow">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-zinc-900">
          Muqami Ranking
        </h2>
        <p className="text-sm text-zinc-500">
          Ranked Muqami collections for {categoryLabel} in the selected reporting-month range.
          {includeLocalFund ? "" : " Local Fund is excluded from displayed totals."}
        </p>
      </div>

      <div className="hidden overflow-x-auto md:block">
        <table className="min-w-full text-sm">
          <thead className="bg-zinc-50 text-left">
            <tr>
              <th className="px-4 py-3 font-medium">Rank</th>
              <th className="px-4 py-3 font-medium">Muqami</th>
              <th className="px-4 py-3 font-medium text-right">Total</th>
              <th className="px-4 py-3 font-medium text-right">Transactions</th>
              <th className="px-4 py-3 font-medium text-right">Avg / Txn</th>
              <th className="px-4 py-3 font-medium text-right">Share</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="px-4 py-6 text-zinc-500" colSpan={6}>
                  Loading Muqami ranking...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td className="px-4 py-6 text-red-600" colSpan={6}>
                  {error}
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td className="px-4 py-6 text-zinc-500" colSpan={6}>
                  No Muqami analytics data for the selected filters.
                </td>
              </tr>
            ) : (
              rows.map((row, index) => (
                <tr className="border-t" key={row.muqamiLabel}>
                  <td className="px-4 py-3 font-semibold text-zinc-500">
                    #{index + 1}
                  </td>
                  <td className="px-4 py-3 font-medium text-zinc-800">
                    {formatMuqamiName(row.muqamiLabel)}
                  </td>
                  <td className="px-4 py-3 text-right font-semibold text-emerald-700">
                    {formatCurrency(row.amount)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {Number(row.overallTransactions ?? 0).toLocaleString("en-MY")}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {formatCurrency(row.averageAmount)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {formatPercent(totalAmount ? (row.amount / totalAmount) * 100 : 0)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="space-y-3 md:hidden">
        {loading ? (
          <div className="rounded-2xl bg-zinc-50 p-4 text-sm text-zinc-500">
            Loading Muqami ranking...
          </div>
        ) : error ? (
          <div className="rounded-2xl bg-red-50 p-4 text-sm text-red-600">
            {error}
          </div>
        ) : rows.length === 0 ? (
          <div className="rounded-2xl bg-zinc-50 p-4 text-sm text-zinc-500">
            No Muqami analytics data for the selected filters.
          </div>
        ) : (
          rows.map((row, index) => (
            <article
              key={row.muqamiLabel}
              className="rounded-2xl border border-zinc-100 bg-white p-4 shadow-sm"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-xs font-bold uppercase tracking-wide text-zinc-400">
                    Rank #{index + 1}
                  </p>
                  <h3 className="mt-1 text-base font-black text-zinc-950">
                    {formatMuqamiName(row.muqamiLabel)}
                  </h3>
                </div>
                <p className="text-right text-sm font-black text-emerald-700">
                  {formatCurrency(row.amount)}
                </p>
              </div>
              <div className="mt-3 grid grid-cols-2 gap-3 text-sm">
                <div>
                  <p className="text-xs uppercase tracking-wide text-zinc-400">
                    Transactions
                  </p>
                  <p className="font-medium text-zinc-800">
                    {Number(row.overallTransactions ?? 0).toLocaleString("en-MY")}
                  </p>
                </div>
                <div>
                  <p className="text-xs uppercase tracking-wide text-zinc-400">
                    Share
                  </p>
                  <p className="font-medium text-zinc-800">
                    {formatPercent(totalAmount ? (row.amount / totalAmount) * 100 : 0)}
                  </p>
                </div>
              </div>
            </article>
          ))
        )}
      </div>
    </div>
  );
};

export default AnalyticsMuqamiRankingTable;
